/**
 * ComfyOutput.jsx
 * Styles for the ComfyOutput component - exactly matches My Collection page style
 */

export const styles = {
  container: "px-4 pb-4 relative w-full max-w-full",
  header: "text-xl py-2 font-bold flex flex-row items-center w-full",
  headerTitle: "span",
  divider: "flex-grow border border-white/40 bg-white/40",
  select: "rounded-lg text-dark-blue border-0 p-2 me-1",
  buttonDanger: "py-2 px-4 mx-1 border rounded bg-red-400 transition",
  controlsContainer: "flex flex-row justify-end items-center p-4",
  paginationButton: "text-4xl p-2",
  disabledPaginationButton: "text-4xl p-2 text-gray-400",
  pageNumberContainer: "text-xl p-2",
  toggleButton: "py-2 px-4 mx-1 border rounded hover:bg-dark-blue transition",
  totalImagesLabel: "font-light mr-5 text-sm",
  totalImagesValue: "font-bold",
  columnSelect: "rounded-lg text-dark-blue border-0 p-2",
  loadingContainer: "w-2/3 mx-auto",
  loadingImage: "w-2/3 mx-auto animate-pulse",
  // Function to return the proper flex layout based on column count
  getFlexClass: (columnClass) => {
    switch(columnClass) {
      case "cols-1":
        return "w-full";
      case "cols-2":
        return "w-1/2";
      case "cols-3":
        return "w-1/3";
      default:
      case "cols-4":
        return "w-1/4";
      case "cols-5":
        return "w-1/5";
      case "cols-6":
        return "w-1/6";
    }
  },
  // Gallery container for images - using flex instead of grid
  galleryGrid: (columnClass) => `flex flex-wrap w-full gap-4 px-4`
};

// Add custom colors to Tailwind config in memory
if (typeof window !== 'undefined' && window.tailwind && window.tailwind.config) {
  window.tailwind.config = {
    ...window.tailwind.config,
    theme: {
      ...window.tailwind.config.theme,
      extend: {
        ...window.tailwind.config.theme.extend,
        colors: {
          ...window.tailwind.config.theme.extend.colors,
          'accent-blue': '#3B82F6',
          'accent-blue-dark': '#2563EB',
        }
      }
    }
  };
} 